// 获取数美deviceId，为了风控使用
export const getSmDeviceId = (): Promise<string> => {
  // 检查运行环境
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('当前环境不支持: window is undefined'));
  }

  if (!window.SMSdk) {
    return Promise.reject(new Error('数美 SDK 未初始化: SMSdk is undefined'));
  }

  return new Promise(resolve => {
    const smTimeoutTime = 100;
    let smDeviceId = '';
    let smDeviceIdReady = false;

    // 超时处理
    const smTimer = setTimeout(() => {
      // @ts-expect-error - SMSdk 的类型定义
      smDeviceId = window.SMSdk.getDeviceId
        ? window.SMSdk.getDeviceId()
        : smDeviceId;

      if (!smDeviceIdReady) {
        smDeviceIdReady = true;
        console.log('通过超时获取设备ID：', smDeviceId);
        resolve(smDeviceId);
      }
    }, smTimeoutTime);

    // SDK ready 处理
    window.SMSdk.ready(() => {
      // @ts-expect-error - SMSdk 的类型定义
      smDeviceId = window.SMSdk.getDeviceId
        ? window.SMSdk.getDeviceId()
        : smDeviceId;
      clearTimeout(smTimer);

      if (!smDeviceIdReady) {
        smDeviceIdReady = true;
        console.log('通过 SDK ready 获取设备ID：', smDeviceId);
        resolve(smDeviceId);
      }
    });
  });
};

// 为了 TypeScript 类型支持，添加全局类型声明
declare global {
  interface Window {
    SMSdk: {
      ready: (callback: () => void) => void;
      getDeviceId?: () => string;
    };
    _smReadyFuncs: Array<() => void>;
    _smConf: {
      organization: string;
      staticHost: string;
    };
  }
}
